// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__GsmyH","closeButton":"styles_closeButton__t3Vj5","closeIcon":"styles_closeIcon__8QevC"};